import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { WEATHER_REPORT_SCHEMA_URL } from './WeatherReport.helpers';
import { WeatherReportGrabber } from './WeatherReportSidebar';

// Lazy load view components
const WeatherReportAdd = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorWeatherReportAdd" */ './WeatherReportSidebar'),
  'WeatherReportAdd',
);

const WeatherReportEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorWeatherReportEdit" */ './admin/WeatherReportEdit'),
  'WeatherReportEdit',
);

const WeatherReportGuest = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorWeatherReportGuest" */ './guest/WeatherReportGuest'),
  'WeatherReportGuest',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const WeatherReportConfig: CustomJsonComponentConfig = {
  schemaUrl: WEATHER_REPORT_SCHEMA_URL,
  componentType: 'WeatherReport',
  adminSidebarComponent: {
    addComponentView: WeatherReportAdd,
    dragComponentView: WeatherReportGrabber,
    editComponentView: WeatherReportEdit,
    createComponentView: WeatherReportEdit,
  },
  guestSiteComponent: WeatherReportGuest,
};
